<template>
  <ion-page>
    <ion-content>
      <div v-if="!isMobile" class="background-image"></div>
      <div class="login-container">
        <img v-if="isMobile" src="@/assets/background.png" />
        <section :style="isMobile ? '' : 'text-align: center;'">
          <div :class="{ container: !isMobile }">
            <div :class="{ container: isMobile }">
              <h1>Reset password</h1>
              <p>Insert the email you want to recover.</p>
            </div>
            <div :style="isMobile ? '' : 'max-width: 600px; margin: 0 auto'">
              <ion-item>
                <ion-label position="stacked">Email</ion-label>
                <ion-input
                  v-model="loginForm.email"
                  name="email"
                  placeholder="john.doe@email.com"
                  type="email"
                ></ion-input>
              </ion-item>
              <div v-if="!isMobile">
                <ion-button
                  expand="block"
                  color="primary"
                  @click="resetPassword()"
                  class="ion-margin-top"
                >
                  <ion-icon slot="start" :icon="sendOutline"></ion-icon>
                  Reset password
                </ion-button>
                <ion-button
                  expand="block"
                  color="dark"
                  fill="clear"
                  router-link="/login"
                  class="ion-margin-top"
                >
                  Back to login
                </ion-button>
              </div>
            </div>
          </div>
        </section>
        <div v-if="isMobile" class="container">
          <section>
            <ion-button
              expand="block"
              color="primary"
              @click="resetPassword()"
              class="ion-margin-top"
            >
              <ion-icon slot="start" :icon="sendOutline"></ion-icon>
              Reset password
            </ion-button>
            <ion-button
              expand="block"
              color="dark"
              fill="clear"
              router-link="/login"
              class="ion-margin-top"
            >
              Back to login
            </ion-button>
          </section>
        </div>
      </div>
    </ion-content>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </ion-page>
</template>

<script setup lang="ts">
import { sendOutline } from "ionicons/icons";
import {
  IonLabel,
  IonLoading,
  IonItem,
  IonInput,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
} from "@ionic/vue";
import { reactive } from "vue";
import { useMyAccount } from "../";
import { requestResetPassword } from "@/api/auth";
import { useToasters } from "@/composition/toasters";
import { useWindowWidth } from "@/composition/window";

const { loginForm } = useMyAccount();
const { isMobile } = useWindowWidth();

const state = reactive({
  loading: false,
  errorMessage: "",
});

const toasters = useToasters();

const resetPassword = () => {
  state.loading = true;
  requestResetPassword(loginForm)
    .then(() => {
      loginForm.email = "";
      state.loading = false;

      toasters.addSuccess(
        "We've sent you an email with the details to reset your password."
      );
    })
    .catch(() => {
      state.loading = false;
      toasters.addError("We could not find an account with this email.");
    });
};
</script>

<style lang="scss" scoped>
.button {
  --padding-start: 0;
  --padding-end: 0;
}

.background-image {
  height: 100vh;
  width: 100%;
  background-image: url("@/assets/background.png");
  background-size: cover;
}

@media (min-width: 768px) {
  .container {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    transform: translate(-50%, -50%);
  }
  .login-container {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
  }
}
</style>
